<mat-tree
  #tree
  [class.--not-desktop]="!isDesktop()"
  igoTreeDragDrop
  [tree]="tree"
  [config]="treeConfig"
  [treeDragDropIsDisabled]="isDragDropDisabled()"
  [maxLevel]="viewerOptions()?.group?.maxHierarchyLevel"
  [dataSource]="layers()"
  [childrenAccessor]="childrenAccessor"
  [trackBy]="trackByFn"
  [expansionKey]="expansionKey"
  (dragStart)="dragStart()"
  (dropped)="dropNode($event)"
  (droppedError)="dropNodeError($event)"
>
  <!-- This is the tree node template for leaf nodes -->
  <mat-tree-node
    #treeNode="matTreeNode"
    *matTreeNodeDef="let node"
    [class.--selected]="isSelected(node)"
    [class.--children-selected]="isDescendantSelection(node)"
  >
    <igo-layer-item
      [matTreeNodePadding]="treeNode.level === 0 ? 1 : treeNode.level"
      [matTreeNodePaddingIndent]="
        treeNode.level === 0 ? 16 : 24 + 16 / treeNode.level
      "
      class="tree-node-item"
      [layer]="node"
      [visible]="node.visible"
      [viewerOptions]="viewerOptions()"
      [selected]="isSelected(node) || isDescendantSelection(node)"
      [selectionDisabled]="isDescendantSelection(node)"
      (action)="toggleActive($event)"
      (selectChange)="handleSelect($event, node)"
    />
  </mat-tree-node>
  <!-- This is the tree node template for expandable nodes -->
  <mat-tree-node
    #treeNode="matTreeNode"
    *matTreeNodeDef="let node; when: isNodeGroup"
    [class.--selected]="isSelected(node)"
    [class.--children-selected]="isDescendantSelection(node)"
  >
    <igo-layer-group
      [matTreeNodePadding]="treeNode.level"
      [matTreeNodePaddingIndent]="24"
      class="tree-node-item"
      [layer]="node"
      [viewerOptions]="viewerOptions()"
      [selected]="isSelected(node) || isDescendantSelection(node)"
      [selectionDisabled]="isDescendantSelection(node)"
      (action)="toggleActive($event)"
      (expand)="handleNodeToggle(node)"
      (selectChange)="handleSelect($event, node)"
    >
      <button
        mat-icon-button
        class="layer-indicator"
        [attr.aria-label]="'Toggle ' + node.title"
        (click)="handleNodeToggle(node)"
      >
        <mat-icon class="mat-icon-rtl-mirror">
          {{
            tree.isExpanded(node)
              ? 'keyboard_arrow_down'
              : 'keyboard_arrow_right'
          }}
        </mat-icon>
      </button>
    </igo-layer-group>
  </mat-tree-node>
</mat-tree>
